import { useEffect, useRef } from "react";
import { acquireModalHistoryEntry } from "../utils/modalHistoryBack";

/** While `isOpen`, Back / iOS swipe-back calls `onClose` instead of navigating away. */
export function useCloseOnHistoryBack(isOpen: boolean, onClose?: (() => void) | null): void {
    const onCloseRef = useRef(onClose);
    onCloseRef.current = onClose;

    useEffect(() => {
        if (!isOpen) return undefined;
        if (typeof onCloseRef.current !== "function") return undefined;
        return acquireModalHistoryEntry(() => {
            onCloseRef.current?.();
        });
    }, [isOpen]);
}

/** Drop-in for overlays that are not function-component-friendly besides a child. */
export function HistoryBackClose({
    open,
    onClose,
}: {
    open: boolean;
    onClose?: (() => void) | null;
}): null {
    useCloseOnHistoryBack(open, onClose);
    return null;
}
